var _rect, _g, _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _g2, _line17, _line18, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg4663",
    width: 1376,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    transform: "translate(0, 0)",
    style: {
      background: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 1376,
    height: 100
  }, /*#__PURE__*/React.createElement("div", {
    className: "apexcharts-legend",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      maxHeight: 50
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect4667",
    width: 0,
    height: 0,
    x: 0,
    y: 0,
    rx: 0,
    ry: 0,
    opacity: 1,
    strokeWidth: 0,
    stroke: "none",
    strokeDasharray: 0,
    fill: "#fefefe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4712",
    className: "apexcharts-yaxis",
    rel: 0,
    transform: "translate(-18, 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4665",
    className: "apexcharts-inner apexcharts-graphical",
    transform: "translate(12, 30)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs4664"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "gridRectMasksy3jn1jz"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect4669",
    width: 1362,
    height: 75,
    x: -6,
    y: -10,
    rx: 0,
    ry: 0,
    opacity: 1,
    strokeWidth: 0,
    stroke: "none",
    strokeDasharray: 0,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "forecastMasksy3jn1jz"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "nonForecastMasksy3jn1jz"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "gridRectMarkerMasksy3jn1jz"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect4670",
    width: 1358,
    height: 59,
    x: -2,
    y: -2,
    rx: 0,
    ry: 0,
    opacity: 1,
    strokeWidth: 0,
    stroke: "none",
    strokeDasharray: 0,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4675",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4676",
    stopOpacity: 0.65,
    stopColor: "rgba(247,166,0,0.65)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4677",
    stopOpacity: 0.5,
    stopColor: "rgba(251,211,128,0.5)",
    offset: 1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4678",
    stopOpacity: 0.5,
    stopColor: "rgba(251,211,128,0.5)",
    offset: 1
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4668",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 55,
    stroke: "#b6b6b6",
    strokeDasharray: 3,
    strokeLinecap: "butt",
    className: "apexcharts-xcrosshairs",
    x: 0,
    y: 0,
    width: 1,
    height: 55,
    fill: "#b1b9c4",
    filter: "none",
    fillOpacity: 0.9,
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4685",
    x1: 0,
    y1: 56,
    x2: 0,
    y2: 62,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-xaxis-tick"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4686",
    x1: 225.66666666666666,
    y1: 56,
    x2: 225.66666666666666,
    y2: 62,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-xaxis-tick"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4687",
    x1: 451.3333333333333,
    y1: 56,
    x2: 451.3333333333333,
    y2: 62,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-xaxis-tick"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4688",
    x1: 677,
    y1: 56,
    x2: 677,
    y2: 62,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-xaxis-tick"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4689",
    x1: 902.6666666666666,
    y1: 56,
    x2: 902.6666666666666,
    y2: 62,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-xaxis-tick"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4690",
    x1: 1128.3333333333333,
    y1: 56,
    x2: 1128.3333333333333,
    y2: 62,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-xaxis-tick"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4691",
    x1: 1354,
    y1: 56,
    x2: 1354,
    y2: 62,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-xaxis-tick"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4681",
    className: "apexcharts-grid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4682",
    className: "apexcharts-gridlines-horizontal",
    style: {
      display: "none"
    }
  }, _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4692",
    x1: 0,
    y1: 0,
    x2: 1354,
    y2: 0,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-gridline"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4693",
    x1: 0,
    y1: 11,
    x2: 1354,
    y2: 11,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-gridline"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4694",
    x1: 0,
    y1: 22,
    x2: 1354,
    y2: 22,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-gridline"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4695",
    x1: 0,
    y1: 33,
    x2: 1354,
    y2: 33,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-gridline"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4696",
    x1: 0,
    y1: 44,
    x2: 1354,
    y2: 44,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-gridline"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4697",
    x1: 0,
    y1: 55,
    x2: 1354,
    y2: 55,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeLinecap: "butt",
    className: "apexcharts-gridline"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4683",
    className: "apexcharts-gridlines-vertical",
    style: {
      display: "none"
    }
  }), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4699",
    x1: 0,
    y1: 55,
    x2: 1354,
    y2: 55,
    stroke: "transparent",
    strokeDasharray: 0,
    strokeLinecap: "butt"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4698",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 55,
    stroke: "transparent",
    strokeDasharray: 0,
    strokeLinecap: "butt"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4684",
    className: "apexcharts-grid-borders",
    style: {
      display: "none"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4671",
    className: "apexcharts-area-series apexcharts-plot-series"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4672",
    className: "apexcharts-series",
    zIndex: 0,
    seriesName: "series-1",
    rel: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4679",
    d: "M0 55L0 55C78.98333333333332 55 146.68333333333334 55 225.66666666666666 55C304.65 55 372.35 55 451.3333333333333 55C530.3166666666666 55 598.0166666666667 55 677 55C755.9833333333333 55 823.6833333333333 55 902.6666666666666 55C981.65 55 1049.35 55 1128.3333333333333 55C1207.3166666666666 55 1275.0166666666667 54.999989 1354 54.999989C1354 54.999989 1354 54.999989 1354 55M1354 54.999989L1354 54.999989 ",
    fill: "url(#SvgjsLinearGradient4675)",
    fillOpacity: 1,
    strokeOpacity: 1,
    strokeLinecap: "butt",
    strokeWidth: 0,
    strokeDasharray: 0,
    className: "apexcharts-area",
    index: 0,
    clipPath: "url(#gridRectMasksy3jn1jz)",
    pathTo: "M 0 55 L 0 55C 78.98333333333332 55 146.68333333333334 55 225.66666666666666 55C 304.65 55 372.35 55 451.3333333333333 55C 530.3166666666666 55 598.0166666666667 55 677 55C 755.9833333333333 55 823.6833333333333 55 902.6666666666666 55C 981.65 55 1049.35 55 1128.3333333333333 55C 1207.3166666666666 55 1275.0166666666667 54.999989 1354 54.999989C 1354 54.999989 1354 54.999989 1354 55M 1354 54.999989z",
    pathFrom: "M 0 55 L 0 55C 78.98333333333332 55 146.68333333333334 55 225.66666666666666 55C 304.65 55 372.35 55 451.3333333333333 55C 530.3166666666666 55 598.0166666666667 55 677 55C 755.9833333333333 55 823.6833333333333 55 902.6666666666666 55C 981.65 55 1049.35 55 1128.3333333333333 55C 1207.3166666666666 55 1275.0166666666667 54.999989 1354 54.999989C 1354 54.999989 1354 54.999989 1354 55M 1354 54.999989z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4680",
    d: "M0 55C78.98333333333332 55 146.68333333333334 55 225.66666666666666 55C304.65 55 372.35 55 451.3333333333333 55C530.3166666666666 55 598.0166666666667 55 677 55C755.9833333333333 55 823.6833333333333 55 902.6666666666666 55C981.65 55 1049.35 55 1128.3333333333333 55C1207.3166666666666 55 1275.0166666666667 54.999989 1354 54.999989 ",
    fill: "none",
    fillOpacity: 1,
    stroke: "#f7a600",
    strokeOpacity: 1,
    strokeLinecap: "butt",
    strokeWidth: 4,
    strokeDasharray: 0,
    className: "apexcharts-area",
    index: 0,
    clipPath: "url(#gridRectMasksy3jn1jz)",
    pathTo: "M 0 55C 78.98333333333332 55 146.68333333333334 55 225.66666666666666 55C 304.65 55 372.35 55 451.3333333333333 55C 530.3166666666666 55 598.0166666666667 55 677 55C 755.9833333333333 55 823.6833333333333 55 902.6666666666666 55C 981.65 55 1049.35 55 1128.3333333333333 55C 1207.3166666666666 55 1275.0166666666667 54.999989 1354 54.999989",
    pathFrom: "M 0 55C 78.98333333333332 55 146.68333333333334 55 225.66666666666666 55C 304.65 55 372.35 55 451.3333333333333 55C 530.3166666666666 55 598.0166666666667 55 677 55C 755.9833333333333 55 823.6833333333333 55 902.6666666666666 55C 981.65 55 1049.35 55 1128.3333333333333 55C 1207.3166666666666 55 1275.0166666666667 54.999989 1354 54.999989",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4673",
    className: "apexcharts-series-markers-wrap apexcharts-hidden-element-shown"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4674",
    className: "apexcharts-datalabels"
  }))), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4700",
    x1: 0,
    y1: 0,
    x2: 1354,
    y2: 0,
    stroke: "#b6b6b6",
    strokeDasharray: 0,
    strokeWidth: 1,
    strokeLinecap: "butt",
    className: "apexcharts-ycrosshairs"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4701",
    x1: 0,
    y1: 0,
    x2: 1354,
    y2: 0,
    strokeDasharray: 0,
    strokeWidth: 0,
    strokeLinecap: "butt",
    className: "apexcharts-ycrosshairs-hidden"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4702",
    className: "apexcharts-xaxis",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4703",
    className: "apexcharts-xaxis-texts-g",
    transform: "translate(0, -4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SvgjsLine4711",
    x1: 0,
    y1: 56,
    x2: 1354,
    y2: 56,
    stroke: "#e0e0e0",
    strokeDasharray: 0,
    strokeWidth: 1,
    strokeLinecap: "butt"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4713",
    className: "apexcharts-yaxis-annotations apexcharts-hidden-element-shown"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4714",
    className: "apexcharts-xaxis-annotations apexcharts-hidden-element-shown"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG4715",
    className: "apexcharts-point-annotations apexcharts-hidden-element-shown"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineImage);
export default __webpack_public_path__ + "static/media/line_image.49d2fb6a368c038dccf5f8392e90ccac.svg";
export { ForwardRef as ReactComponent };